import { useEffect, useState } from "react";
import { CountryCodes, PracticeSystems } from "../../constants";
import { getStates_Ajax } from "../../helpers/requests";
import InputMask from "react-input-mask";

const DentistEnrollmentPracticeInfo = ({
  formData,
  handleChange,
  onNext,
  onBack,
  errors
}) => {
  const ErrorMsg = ({ msg }) =>
    msg ? <div className="text-danger small mt-1">{msg}</div> : null;
  const [states, setStates] = useState([]);

  useEffect(() => {
    getStates(CountryCodes.US);
  }, []);

  const getStates = (countryCode) => {
    if (!countryCode) return;
    getStates_Ajax(
      countryCode,
      (res) => {
        if (res?.success && res?.data) {
          setStates(res.data.map((s) => ({ value: s.value, label: s.name })));
        }
      },
      () => {}
    );
  };
  return (
    <>
      <div
        className="alert alert-primary py-2 px-3 border-0 text-primary bg-opacity-10 mb-4"
        role="alert"
      >
        <strong>*</strong> All fields are required
      </div>

      <div className="mb-4">
        <h5 className="border-bottom pb-2 mb-3 text-dark text-xl">
          Basic Information
        </h5>
        <div className="row g-3">
          <div className="col-md-6">
            <label className="form-label small fw-bold text-muted">
              Practice Name <span className="text-danger">*</span>
            </label>
            <input
              type="text"
              className={`form-control ${
                errors.practiceName ? "is-invalid" : ""
              }`}
              name="practiceName"
              value={formData.practiceName}
              onChange={handleChange}
              placeholder="Enter practice name"
            />
            <ErrorMsg msg={errors.practiceName} />
          </div>
          <div className="col-md-6">
            <label className="form-label small fw-bold text-muted">
              Primary Dentist Name <span className="text-danger">*</span>
            </label>
            <input
              type="text"
              className={`form-control ${
                errors.primaryDentistName ? "is-invalid" : ""
              }`}
              name="primaryDentistName"
              value={formData.primaryDentistName}
              onChange={handleChange}
              placeholder="Dr. John Smith"
            />
            <ErrorMsg msg={errors.primaryDentistName} />
          </div>
        </div>
      </div>

      <div className="mb-4">
        <h5 className="border-bottom pb-2 mb-3 text-dark text-xl">
          Practice Address
        </h5>
        <div className="mb-3">
          <label className="form-label small fw-bold text-muted">
            Street Address <span className="text-danger">*</span>
          </label>
          <input
            type="text"
            className={`form-control ${
              errors.streetAddress ? "is-invalid" : ""
            }`}
            name="streetAddress"
            value={formData.streetAddress}
            onChange={handleChange}
            placeholder="123 Main Street"
          />
          <ErrorMsg msg={errors.streetAddress} />
        </div>
        <div className="row g-3">
          <div className="col-md-5">
            <label className="form-label small fw-bold text-muted">
              City <span className="text-danger">*</span>
            </label>
            <input
              type="text"
              className={`form-control ${errors.city ? "is-invalid" : ""}`}
              name="city"
              value={formData.city}
              onChange={handleChange}
              placeholder="City"
            />
            <ErrorMsg msg={errors.city} />
          </div>
          <div className="col-md-4">
            <label className="form-label small fw-bold text-muted">
              State <span className="text-danger">*</span>
            </label>
            <select
              className={`form-select ${errors.state ? "is-invalid" : ""}`}
              name="state"
              value={formData.state}
              onChange={handleChange}
            >
              <option value="">Select State</option>
              {states.map((s) => (
                <option key={s.value} value={s.value}>
                  {s.label}
                </option>
              ))}
            </select>
          </div>
          <div className="col-md-3">
            <label className="form-label small fw-bold text-muted">
              ZIP Code <span className="text-danger">*</span>
            </label>
            <input
              type="text"
              className={`form-control ${errors.zipCode ? "is-invalid" : ""}`}
              name="zipCode"
              value={formData.zipCode}
              onChange={handleChange}
              placeholder="12345"
            />
            <ErrorMsg msg={errors.zipCode} />
          </div>
        </div>
      </div>

      <div className="mb-4">
        <h5 className="border-bottom pb-2 mb-3 text-dark text-xl">
          Contact Information
        </h5>
        <div className="row g-3 mb-3">
          <div className="col-md-6">
            <label className="form-label small fw-bold text-muted">
              Phone Number <span className="text-danger">*</span>
            </label>

            <InputMask
              mask="(999)-999-9999"
              className={`form-control ${errors.phone ? "is-invalid" : ""}`}
              name="phone"
              value={formData.phone}
              onChange={handleChange}
              placeholder="(555) 123-4567"
              inputMode="numeric"
            />
            <ErrorMsg msg={errors.phone} />
          </div>
          <div className="col-md-6">
            <label className="form-label small fw-bold text-muted">
              Email <span className="text-danger">*</span>
            </label>
            <input
              type="email"
              className={`form-control ${errors.email ? "is-invalid" : ""}`}
              name="email"
              value={formData.email}
              onChange={handleChange}
              placeholder="practice@example.com"
            />
            <ErrorMsg msg={errors.email} />
          </div>
        </div>
        <div className="row g-3">
          <div className="col-md-6">
            <label className="form-label small fw-bold text-muted">
              Website or Booking Link
            </label>
            <input
              type="text"
              className="form-control"
              name="website"
              value={formData.website}
              onChange={handleChange}
              placeholder="https://yourpractice.com"
            />
          </div>
          <div className="col-md-6">
            <label className="form-label small fw-bold text-muted">
              NPI Number <span className="text-danger">*</span>
            </label>
            <input
              type="text"
              className={`form-control ${errors.npi ? "is-invalid" : ""}`}
              name="npi"
              value={formData.npi}
              onChange={handleChange}
              placeholder="1234567890"
            />
            <ErrorMsg msg={errors.npi} />
          </div>
        </div>
      </div>

      <div className="mb-5">
        <div className="col-12">
          <label className="form-label small fw-bold text-muted">
            Practice Management System
          </label>
          <select
            className="form-select"
            name="system"
            value={formData.system}
            onChange={handleChange}
            placeholder="Practice Management System"
          >
            <option value="" disabled selected hidden>
              Select your system
            </option>
            {PracticeSystems.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
        </div>
      </div>

      <div className="text-center">
        <button
          type="button"
          onClick={onBack}
          className="btn btn-outline-secondary btn-sm rounded-pill px-5 py-2 fw-bold shadow-sm mb-3 mx-1"
        >
          Back
        </button>
        <button
          type="button"
          onClick={onNext}
          className="btn pi-btn-gradient text-white rounded-pill px-5 py-2 fw-bold shadow-sm mb-3"
        >
          Next
        </button>
      </div>
    </>
  );
};

export default DentistEnrollmentPracticeInfo;
